import api from './api'

export default {
  // POST /api/cuentas-por-cobrar — crea la venta a crédito (emite la cuota 1)
  async crear (crearVentaCreditoDto) {
    const response = await api.post('/cuentas-por-cobrar', crearVentaCreditoDto)
    return response.data
  },

  // GET /api/cuentas-por-cobrar?soloConSaldo=
  async getAll (params = {}) {
    const response = await api.get('/cuentas-por-cobrar', { params })
    return response.data
  },

  // GET /api/cuentas-por-cobrar/:planId
  async getById (planId) {
    const response = await api.get(`/cuentas-por-cobrar/${planId}`)
    return response.data
  },

  // POST /api/cuentas-por-cobrar/:planId/cuotas/:numero/pagar
  async pagarCuota (planId, numero, registrarPagoCuotaDto) {
    const response = await api.post(
      `/cuentas-por-cobrar/${planId}/cuotas/${numero}/pagar`,
      registrarPagoCuotaDto
    )
    return response.data
  },

  // GET /api/cuentas-por-cobrar/:planId/cuotas/:numero/mora-estimada
  async estimarMora (planId, numero) {
    const response = await api.get(`/cuentas-por-cobrar/${planId}/cuotas/${numero}/mora-estimada`)
    return response.data
  },

  // GET /api/cuentas-por-cobrar/configuracion-mora
  async getConfiguracionMora () {
    const response = await api.get('/cuentas-por-cobrar/configuracion-mora')
    return response.data
  },

  // PUT /api/cuentas-por-cobrar/configuracion-mora
  async updateConfiguracionMora (dto) {
    const response = await api.put('/cuentas-por-cobrar/configuracion-mora', dto)
    return response.data
  },

  // POST /api/cuentas-por-cobrar/:planId/refinanciar
  async refinanciar (planId, dto) {
    const response = await api.post(`/cuentas-por-cobrar/${planId}/refinanciar`, dto)
    return response.data
  }
}
